var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error)?_c('section',{staticClass:"container error-message-section"},[_c('div',{staticClass:"error-message-section__inner"},[_c('img',{attrs:{"src":"/img/result/cross.svg","alt":"","width":"18","height":"18"}}),_vm._v(" "),_c('p',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.error))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }